import React from "react";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import ProgressButton from "../../ProgressButton";

const classes = {
    actionButton: css``,
};

const ButtonReviewData = (props) => {
    const { t } = useTranslation();

    return (
        <>
            <ProgressButton
                variant="contained"
                disabled={!(props.selectedCountryNumericCode || props.selectedRegion)}
                loading={props.loadingTables}
                className={classes.actionButton}
                onClick={props.onReviewData}
            >
                {t("Review data")}
            </ProgressButton>
        </>
    );
};

export default ButtonReviewData;
